"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IcatuProposalStatus = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
var IcatuProposalStatus;
(function (IcatuProposalStatus) {
    IcatuProposalStatus["InCreation"] = "DIGITADA";
    IcatuProposalStatus["AcceptanceRequested"] = "ACEITACAOSOLICITADA";
    IcatuProposalStatus["Created"] = "EFETIVADA";
    IcatuProposalStatus["Review"] = "ANALISE";
    IcatuProposalStatus["Pending"] = "PENDENTE";
    IcatuProposalStatus["WithRestrictions"] = "COMRESTRICAO";
    IcatuProposalStatus["Deployed"] = "IMPLANTADA";
    IcatuProposalStatus["Refused"] = "RECUSADA";
    IcatuProposalStatus["RefusedChargeback"] = "RECUSADACOMDEVOLUCAOPREMIO";
    IcatuProposalStatus["WaitingSignature"] = "PENDENTEASSINATURA";
})(IcatuProposalStatus = exports.IcatuProposalStatus || (exports.IcatuProposalStatus = {}));
//# sourceMappingURL=IcatuProposalStatus.js.map